import {
  ActionReducerMap,
  MemoizedSelector,
  createFeatureSelector
} from '@ngrx/store';

import * as fromCompanySettings from './company-settings.reducer';

export interface CompanyState {
  companySettings: fromCompanySettings.CompanySettingsState;
}

export const reducers: ActionReducerMap<CompanyState> = {
  companySettings: fromCompanySettings.reducer
};

export const getCompanyState: MemoizedSelector<
  object,
  CompanyState
> = createFeatureSelector<CompanyState>('company');
